module.exports = __webpack_public_path__ + "img/番外_开国大典_05_家宴.1f0328a1.png";